export enum InputAction {
  Handshake = 'Handshake',
  Downloads_All = 'Downloads_All',
  Download_Status = 'Download_Status',
  AppSettings = 'AppSettings',
  Player_Closed = 'Player_Closed',
}

export enum DownloadStatus {
  IDLE = 'IDLE',
  WAITING = 'WAITING',
  QUEUED = 'QUEUED',
  DOWNLOADING = 'DOWNLOADING',
  PAUSED = 'PAUSED',
  ERROR = 'ERROR',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  REMOVED = 'REMOVED',
  DISABLED = 'DISABLED',
  CANCELLING = 'CANCELLING',
  REMOVING = 'REMOVING',
  RETRYING = 'RETRYING',
  PAUSING = 'PAUSING'
}

export type DownloadStatusResponse = keyof typeof DownloadStatus

export enum DownloadQuality {
  GOOD = 'GOOD',
  BETTER = 'BETTER',
  BEST = 'BEST',
}

export type DownloadQualityResponse = keyof typeof DownloadQuality

// Handshake
export type HandshakePayload = {
  uwpRequestTime: number
}
export type HandlerHandshake = (p: HandshakePayload) => void

export enum StatusMessageType {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR'
}

export interface StatusMessage {
  "code": string
  "type": StatusMessageType
  "message": string
  "localization": "string"|"id"
}

export enum ConstraintType {
  RENTAL = "rental",
  OFFLINE = "offline"
}

export type BeforePlayModals = {
  "Type": ConstraintType
  "TimeWindow": number
}

export type Timers = {
    "Type": ConstraintType
    "ExpiresOn": number
}

// GetAllDownloads
export type DownloadStatusPayload = {
  "DownloadId": string,
  "TitleId": string,
  "Status": DownloadStatusResponse,
  "Progress": number,
  "Quality": DownloadQualityResponse,
  "Size": number,
  "NeedsLicense": boolean
  "LicenseExpirationDate": number
  "LicenseExpireAfterFirstPlay": number
  "LicenseUsableForPlay": boolean
  "StartTime": number
  "ResumeTime": number
  "Messages": StatusMessage[]
  "ProfileId": string
  "FullMetadata": FullMetadata[]
  "Modals": BeforePlayModals[],
  "Timers": Timers[]
}

export type FullMetadata = {
  "Gti": string
  "PrimaryTitle": boolean
  "Type": string
  "Title": string
  "Synopsis": string
  "EpisodeNumber": number
  "SeasonNumber": number
  "Runtime": number
}

export type AllDownloadsPayload = {
  [titleId: string]: DownloadStatusPayload
}
export type HandlerDownloadsAll = (p: AllDownloadsPayload) => void

// GetAppSettings
export interface AppSettingsPayload {
  downloadQuality: string
  appVersion: string
  deviceId: string
  deviceName: string
  downloadOnMobileData: boolean
  freeSpace: number
  capacitySpace: number
  usedSpace: number
  canSendFeedback: boolean
}

export type HandlerGetAppSettings = (p: AppSettingsPayload) => void


// DownloadStatus
export type HandlerDownloadStatus = (p: DownloadStatusPayload) => void

// 'Player_Closed' notification handler
export type HandlerPlayerClosed = (p: DownloadStatusPayload) => void

export type InputHandlers =
  | HandlerHandshake
  | HandlerDownloadsAll
  | HandlerDownloadStatus
  | HandlerGetAppSettings

export type InputActions = keyof typeof InputAction
